import React, { useState } from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonCard,
  IonCardContent,
  IonIcon,
  IonButton,
  useIonViewWillEnter,
} from '@ionic/react';
import {
  barbellOutline,
  chevronForwardOutline,
  personCircleOutline,
} from 'ionicons/icons';

import { HighscoreContent } from '../../statistics/highscore/Highscore';
import TrainingSessionsWidget from '../../trainings/training_sessions/TrainingSessionsWidget';

import './Statistics.css';

const Statistics: React.FC = () => {
  const [refreshVersion, setRefreshVersion] = useState(0);

  // Ionic caches tab pages instead of remounting them. Recreate the statistics
  // content whenever this view becomes active so it reads the latest local DB data.
  useIonViewWillEnter(() => {
    setRefreshVersion(version => version + 1);
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              padding: '0 12px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <img
                src="/assets/pl_icon/icon_nf_matt.png"
                alt="Pawer Lifting"
                style={{ height: 50, width: 'auto', display: 'block' }}
              />
              <strong>Statistics</strong>
            </div>

            <IonButton
              shape="round"
              fill="clear"
              aria-label="Account"
              routerLink="/my/settings"
            >
              <IonIcon icon={personCircleOutline} slot="icon-only" />
            </IonButton>
          </div>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="statistics-content">
        <HighscoreContent
          key={`statistics-${refreshVersion}`}
          middleContent={
            <>
              <IonCard
                className="statistics-machine-card"
                routerLink="/my/machines"
                button
              >
                <IonCardContent>
                  <div className="statistics-machine-card__icon">
                    <IonIcon icon={barbellOutline} />
                  </div>
                  <div>
                    <span>Exercise library</span>
                    <h2>Browse machines</h2>
                    <p>
                      Review equipment and the muscles each exercise targets.
                    </p>
                  </div>
                  <IonIcon
                    icon={chevronForwardOutline}
                    className="statistics-machine-card__arrow"
                  />
                </IonCardContent>
              </IonCard>

              <section className="statistics-sessions">
                <TrainingSessionsWidget variant="preview" />
              </section>
            </>
          }
        />
      </IonContent>
    </IonPage>
  );
};

export default Statistics;
